(function() {
    'use strict';
    if (window.CMWWebMCP) { return; }

    var controller = null;
    var pending = Promise.resolve();
    var suspended = false;
    var generation = 0;
    var text = { type: 'string', maxLength: 200 };
    var contextSchema = { type: 'object', properties: { context_id: text }, required: ['context_id'], additionalProperties: false };
    var configureSchema = {
        type: 'object', additionalProperties: false, required: ['context_id'],
        properties: {
            context_id: text, size_sku: text, vehicle_year: text, vehicle_make: text,
            vehicle_model: text, color_code: text, color_name: text,
            project_notes: { type: 'string', maxLength: 4000 },
            addon_variant_ids: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        }
    };

    function invoke(operation, input, options) {
        try {
            if (options && options.signal && options.signal.aborted) {
                return JSON.stringify({ ok: false, error: { code: 'cancelled' } });
            }
            if (!input || typeof input !== 'object' || Array.isArray(input)) {
                return JSON.stringify({ ok: false, error: { code: 'invalid_input' } });
            }
            if (operation === 'requirements' && Object.keys(input).length) {
                return JSON.stringify({ ok: false, error: { code: 'unknown_field' } });
            }
            if (operation === 'summary' && Object.keys(input).some(function(key) { return key !== 'context_id'; })) {
                return JSON.stringify({ ok: false, error: { code: 'unknown_field' } });
            }
            var adapter = window.CMWOrderCustomizer;
            if (!adapter) { throw new Error('adapter_unavailable'); }
            var result = operation === 'requirements' ? adapter.requirements() :
                operation === 'summary' ? adapter.summary(input.context_id) : adapter.configure(input);
            return JSON.stringify({ ok: true, data: result });
        } catch (error) {
            return JSON.stringify({ ok: false, error: { code: error.code || 'customizer_unavailable' } });
        }
    }

    function tool(name, description, schema, operation, readOnly) {
        return {
            name: name, description: description, inputSchema: schema,
            annotations: { readOnlyHint: readOnly, untrustedContentHint: true, consequentialHint: false },
            execute: function(input, options) { return invoke(operation, input, options); }
        };
    }

    function stop() {
        if (controller) { controller.abort(); controller = null; }
    }

    function refresh() {
        var requested = ++generation;
        stop();
        // Serialize async registration so section events never race duplicate names.
        pending = pending.then(async function() {
            if (requested !== generation) { return; }
            stop();
            var api = document.modelContext;
            var adapter = window.CMWOrderCustomizer;
            if (suspended || !api || typeof api.registerTool !== 'function' || !adapter || !adapter.requirements().length) {
                return;
            }
            var current = new AbortController();
            controller = current;
            var tools = [
                tool('cmw_get_order_requirements',
                    'Read current CMW made-to-order form contexts, size SKUs, optional add-ons, required vehicle fields and customer acknowledgement text. Color codes are customer supplied, not catalog variants or verified OEM identities.',
                    { type: 'object', properties: {}, additionalProperties: false }, 'requirements', true),
                tool('cmw_configure_order',
                    'Fill the visible CMW customizer for an explicit context_id from requirements. Use its available size_sku and addon_variant_ids. Preserve customer color-code text. Return current summary for review; this does not accept acknowledgement, upload files, add to cart or place an order.',
                    configureSchema, 'configure', false),
                tool('cmw_get_order_summary',
                    'Read current CMW form properties, selected size/variant, add-ons, quantity, image presence, missing fields and customer acknowledgement. Form completeness is not OEM verification, manufacturing approval or an order submission.',
                    contextSchema, 'summary', true)
            ];
            try {
                for (var i = 0; i < tools.length; i++) {
                    if (current.signal.aborted || suspended) { return; }
                    await api.registerTool(tools[i], { signal: current.signal });
                }
            } catch (error) {
                current.abort();
                if (controller === current) { controller = null; }
                document.dispatchEvent(new CustomEvent('cmw:webmcp-status', { detail: { status: 'registration_failed' } }));
            }
        }).catch(function() {
            stop();
        });
        return pending;
    }

    window.CMWWebMCP = Object.freeze({ refresh: refresh });
    document.addEventListener('shopify:section:load', function(event) {
        if (event.target instanceof Element) {
            event.target.querySelectorAll('[data-cmw-webmcp-unloading]').forEach(function(node) {
                node.removeAttribute('data-cmw-webmcp-unloading');
            });
        }
        refresh();
    });
    document.addEventListener('shopify:section:unload', function(event) {
        stop();
        // Shopify dispatches unload before removing the section DOM.
        if (event.target instanceof Element) {
            event.target.querySelectorAll('.js-cmw-customizer').forEach(function(node) {
                node.setAttribute('data-cmw-webmcp-unloading', 'true');
            });
        }
        refresh();
    });
    window.addEventListener('pagehide', function() { suspended = true; generation++; stop(); });
    window.addEventListener('pageshow', function() { suspended = false; refresh(); });
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', refresh, { once: true });
    } else {
        refresh();
    }
})();
